import axios from 'axios';

const NotificationService = {
  async get() {
    try {
      const url = axios.defaults.baseURL.replace('/moya/pilot/api', '/moya/notification/index/json');
      return axios.get(url);
    }
    catch (e) {
      throw new Error(e);
    }
  },
};

export default NotificationService;
